<template>
  <v-select :items="items" label="Status" :value="value" @change="emitValue" clearable></v-select>
</template>

<script>
import API from '@/services/api.js'
import groupBy from 'lodash/groupBy'

// @group Order
// ApplicationStateSelect component
export default {
  name: 'ApplicationStateSelect',

  props: {
    // The v-model value
    value: {
      type: Array
    },
  },

  data: () => ({
    allItems: [],
    allGroups: [],
    items: []
  }),

  created () {
    API.listDistanceOrderStates()
      .then(response => {
       this.allItems = response.data
       this.allGroups = groupBy(this.allItems, 'name')
       this.items = Object.keys(this.allGroups).map(o => { return { 
          value: this.allGroups[o].map(g=>{ return g.id }), text: (o === 'Beställd' ? 'Beställda distansutbildningar' : o)
        }})
      })
      .catch(error => {
        console.log('There was an error:', error)
      })
  },
  methods: {
    emitValue (value) {
      // Fire when selection is changed
      // @arg The argument is the value of the selected option
      this.$emit('input', value)
    }
  }
}
</script>

<style>
</style>